// avoid changing react-mentions source code, just disable lint for now
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  id: '__id__',
  display: '__display__'
};
